import { render, staticRenderFns } from "./NbPageTitle.vue?vue&type=template&id=1e715632&scoped=true&"
import script from "./NbPageTitle.vue?vue&type=script&lang=js&"
export * from "./NbPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./NbPageTitle.vue?vue&type=style&index=0&id=1e715632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e715632",
  null
  
)

export default component.exports